let view = null;

export default {
	namespace: 'single-course',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: CourseView } = await import(
			/* webpackChunkName: "course-view" */ '../../templates/CourseView'
		);
		view = new CourseView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
